var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTextField',{attrs:{"label":_vm.label,"value":_vm.value,"required":_vm.required || false,"disabled":_vm.disabled,"persistent-hint":!!_vm.info,"hint":_vm.info,"rules":_vm.required ? _vm.isRequired : []},on:{"input":function($event){return _vm.$emit('change', {val: $event, name: _vm.name})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }